import request from 'utils/request'

export function loadUsers() {
  return request('admin/customers', {
    method: 'GET'
  }).then(([body]) => body)
}

export function updateUserPremium(data, userId) {
  return request(`admin/customers/premium/${userId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function updateUserApiService(data, userId) {
  return request(`admin/customers/api-service/${userId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function updateUserLimit(data, userId) {
  return request(`admin/customers/limit/${userId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function updateUserApiServiceLimit(data, userId) {
  return request(`admin/customers/api-service-limit/${userId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function updateUserDisabled(data, userId) {
  return request(`admin/customers/disable/${userId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function getCognitoUser(data) {
  return request('users/me', {
    method: 'POST',
    data
  }).then(([body]) => body)
}
